import { render, staticRenderFns } from "./MovimientosTable.vue?vue&type=template&id=33d561aa&scoped=true&"
import script from "./MovimientosTable.vue?vue&type=script&lang=js&"
export * from "./MovimientosTable.vue?vue&type=script&lang=js&"
import style0 from "./MovimientosTable.vue?vue&type=style&index=0&id=33d561aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d561aa",
  null
  
)

export default component.exports